// import $ from 'jquery'
// import Vue from "vue";
// // import * as lodash from "lodash";
//时间日期时间戳转正常日期格式
export function changeDate(dateA) {
    var dateee = new Date(dateA).toJSON();
    var date = new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '');
    return date;
}
/**
 * 获取base64格式的回调函数
 * @param URLData 获取的base64格式
 */
//  function getBase64(URLData){
//     //  return "base64" + URLData;
//      console.log("base64",URLData)
//  }

/**
 * Base64转
 * @param base64 String base64格式字符串
 * @param contentType String file对象的文件类型，如："image/png"
 * @param filename String 文件名称或者文件路径
 */
// export function translateBase64ImgToFile(base64,filename,contentType){
//     var arr = base64.split(',')  //去掉base64格式图片的头部
//     var bstr = atob(arr[1])   //atob()方法将数据解码
//     var leng = bstr.length
//     var u8arr = new Uint8Array(leng)
//     while(leng--){
//         u8arr[leng] =  bstr.charCodeAt(leng) //返回指定位置的字符的 Unicode 编码
//     }
//     return new File([u8arr],filename,{type:contentType})
// }
// export function getBase64(img){
//     function getBase64Image(img,width,height) {//width、height调用时传入具体像素值，控制大小 ,不传则默认图像大小
//         var canvas = document.createElement("canvas");
//         canvas.width = width ? width : img.width;
//         canvas.height = height ? height : img.height;
//
//         var ctx = canvas.getContext("2d");
//         ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
//         var dataURL = canvas.toDataURL();
//         return dataURL;
//     }
//     var image = new Image();
//     image.crossOrigin = '';
//     image.src = img;
//     var deferred=$.Deferred();
//     if(img){
//         image.onload =function (){
//             deferred.resolve(getBase64Image(image));//将base64传给done上传处理
//         }
//         return deferred.promise();//问题要让onload完成后再return sessionStorage['imgTest']
//     }}
